<template>
  <div class="page-heading">
    <slot name="heading"></slot>
  </div>
  <div class="page-content mt-3">
    <div class="row">
      <div class="col-md-12">
        <div class="card" style="width: 100%">
          <div class="card-body">
            <slot>
              <div class="d-flex justify-content-center">
                <div
                  class="spinner-border m-5"
                  style="width: 4rem; height: 4rem"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
  <teleport to="body">
    <!-- Create Modal -->
    <div
      class="modal fade"
      id="createModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <slot name="createModal"></slot>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <!-- Edit Modal -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <slot name="editModal"></slot>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <!-- Create Modal Large -->
    <div
      class="modal fade"
      id="createLargeModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <slot name="createLargeModal"></slot>
      </div>
    </div>
  </teleport>
  <teleport to="body">
    <!-- Edit Modal Large -->
    <div
      class="modal fade"
      id="editLargeModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <slot name="editLargeModal"></slot>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  props: ['isLoading']
};
</script>

<style scoped>
:deep(.table) {
  font-size: 13px;
  font-style: normal;
}
.table thead > tr > :deep(th) {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background: #f3f3f3;
}
:deep(.btn-xs) {
  padding: 0.15rem 0.3rem !important;
  font-size: 0.75rem !important;
}
</style>
